<tran-ui-content-section>
    @let app = application();

    <div class="flex flex-col gap-4 max-w-[720px] py-10">
        @if (isLoadingApplication()) {
            <span class="si-skeleton placeholder-lg w-40" aria-hidden="true"></span>
            <span class="si-skeleton placeholder-lg w-[520px]" aria-hidden="true"></span>
        } @else if (app) {
            <span class="font-bold text-topline-l">#{{ app.number }}</span>
            <h1 class="text-hero-l2">{{ app.name }}</h1>
        }
    </div>
    <div class="flex flex-col lg:flex-row !gap-6 pb-6">
        <div class="flex flex-col w-full lg:w-3/5 xl:w-[66.875%] !gap-6">
            <tran-application-information
                [requesters]="app?.applicants ?? []"
                [affectedLocations]="app?.locations ?? []"
                [involvedOrganizations]="app?.affectedOrgUnits ?? []"
                [isLoading]="isLoadingApplication()"
                [readonly]="readonly()"
            />
            <tran-application-responsibilities
                [partners]="app?.partners ?? []"
                [businessResponsible]="app?.businessResponsible"
                [technicalResponsible]="app?.technicalResponsible"
                [commercialResponsible]="app?.commercialResponsible"
                [isLoading]="isLoadingApplication()"
                [readonly]="readonly()"
            />
            <tran-application-influence-and-impact
                [contribution]="app?.contribution ?? null"
                [involvement]="app?.involvement ?? null"
                [transferAndScalability]="app?.transferAndScalability ?? null"
                [selectedKpis]="applicationKpis()"
                [isLoading]="isLoadingApplication()"
                [readonly]="readonly()"
            />
            <tran-application-additional-subject-areas
                [selectedSubjectAreas]="app?.subjectAreas ?? []"
                [additionalSubjectAreas]="app?.additionalSubjectAreas ?? []"
                [isLoading]="isLoadingApplication()"
                [readonly]="readonly()"
            />
            <tran-application-detail-textarea
                heading="application-form.subject-area-notes-title"
                placeholder="application-form.subject-area-notes-description"
                [value]="app?.formerProjectInformation ?? ''"
                [isLoading]="isLoadingApplication()"
                [readonly]="readonly()"
            />
            <tran-application-detail-textarea
                heading="application-detail.application-note.header"
                placeholder="application-detail.application-note.placeholder"
                [value]="app?.comment ?? ''"
                [isLoading]="isLoadingApplication()"
                [readonly]="readonly()"
            />
        </div>
        <div class="flex flex-col w-full lg:w-2/5 xl:w-[31.25%] !gap-6">
            <tran-application-status-detail
                [isLoading]="isLoadingApplication()"
                [readonly]="true"
                [status]="app?.status ?? applicationStatusEnum.Draft"
                [selectedAwardCommitteeMeeting]="selectedAwardCommitteeMeeting()"
                [isSelectedAwardCommitteeLoading]="isSelectedAwardCommitteeMeetingLoading()"
            />
            @if (app?.startDate; as startDate) {
                <tran-application-detail-deadlines
                    [isLoading]="isLoadingApplication()"
                    [readonly]="true"
                    [startDate]="startDate"
                    [endDate]="app?.endDate"
                />
            }
            <div class="flex flex-col min-[1800px]:flex-row w-full gap-6">
                <div class="flex-1">
                    <tran-application-detail-affected-employees
                        [isLoading]="isLoadingApplication()"
                        [readonly]="true"
                        [value]="app?.affectedEmployees"
                    />
                </div>
                <div class="flex-1">
                    <tran-application-detail-employee-learning-hours
                        [isLoading]="isLoadingApplication()"
                        [readonly]="true"
                        [value]="app?.employeeLearningHours"
                    />
                </div>
            </div>
            <tran-application-detail-budget
                [isLoading]="isLoadingApplication()"
                [readonly]="true"
                [budgets]="app?.budgets ?? []"
            />
            <tran-application-detail-approved-budget
                [isLoading]="isLoadingApplication()"
                [readonly]="readonly()"
                [value]="app?.approvedBudget || null"
            />
            <tran-application-attachments
                [isLoading]="isLoadingApplication()"
                [attachments]="attachments()"
                [hasMoreAttachments]="!!attachmentsMetadata()?.cursor"
                (loadMore)="loadMoreAttachments()"
                (download)="downloadAttachment($event)"
            />
        </div>
    </div>
</tran-ui-content-section>
